import React from 'react';
import dayjs from 'dayjs';

//Estilos
import './DJCEPrint.css';
import logo from '../../assets/imgs/logo_inavi.png';
import { formatNumberLength } from '../../helpers';

function DJCEPrint({ functions, states, reference }) {
    const { formatNumber, setPrint } = functions;

    const { masters, print, DJCEData, Coordinates } = states;

    const Titulares = DJCEData?.declaracion?.titulares?.split('/');
    const TitularesDoc = DJCEData?.declaracion?.titulares_Documento?.split('/');

    return (
        <div className="DJCEPrint-container">
            <div ref={reference} className="DJCEPrint-parent">
                <header className="DJCEPrint-header">
                    <img className="DJCEPrint-logo" src={logo} alt="INAVI" />
                    <div className="DJCEPrint-header-title">
                        <h2>DECLARACIÓN JURADA DE COSECHA EFECTIVA DE UVA</h2>
                        <h3>(Ley Nº13.665 de 17-06-1968)</h3>
                    </div>
                    <h3>
                        {DJCEData?.declaracion?.serie}-
                        {masters.LetterTypes?.find((lt) => lt.id === 4).nombre}-
                        {formatNumber(DJCEData?.declaracion?.numero, 4)}
                    </h3>
                </header>
                <section className="DJCEPrint-info-section">
                    <table>
                        <tbody>
                            <tr>
                                <td>VIÑEDO: </td>
                                <td>{DJCEData?.declaracion?.viniedo}</td>
                                <td>TELÉFONO: </td>
                                <td>{DJCEData?.declaracion?.telefono}</td>
                            </tr>
                            {Titulares?.map((t, i) => {
                                return (
                                    <tr key={i}>
                                        <td>TITULAR: </td>
                                        <td>{t}</td>
                                        <td>DOCUMENTO: </td>
                                        <td>
                                            {TitularesDoc
                                                ? TitularesDoc[i]
                                                : ''}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <section className="DJCEPrint-info-section">
                    <table>
                        <tbody>
                            <tr>
                                <td>FECHA: </td>
                                <td>
                                    {dayjs(DJCEData?.declaracion?.fecha).format(
                                        'DD-MM-YYYY'
                                    )}
                                </td>

                                <td>TIMBRE: </td>
                                <td>
                                    {DJCEData?.declaracion?.timbre
                                        ? 'PAGO'
                                        : 'NO PAGO'}
                                </td>
                            </tr>
                            <tr>
                                <td>SUPERFICIE: </td>
                                <td>
                                    {DJCEData?.declaracion?.total_Superficie} m²
                                </td>
                                <td>PADRONES: </td>
                                <td>
                                    {DJCEData?.declaracion?.padrones.replace(
                                        '_',
                                        ', '
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td>UBICACIÓN: </td>
                                <td>
                                    Lat: {formatNumberLength(Coordinates?.lat)},
                                    Long: {formatNumberLength(Coordinates?.lon)}
                                </td>
                                <td>DEPARTAMENTO: </td>
                                <td>{DJCEData?.declaracion?.departamento}</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <section className="DJCEPrint-production-section">
                    <h4>GUÍAS UTILIZADAS</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>Destino</th>
                                <th>Comprador</th>
                                <th>Nro Inscripción del Comprador</th>
                                <th>Nro Guía</th>
                                <th>Variedad</th>
                                <th>Kilos</th>
                                <th>Grado Glucosa</th>
                                <th>Precio por Kg</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DJCEData?.djceGuias?.map((dg, i) => {
                                return (
                                    <tr key={i}>
                                        <td>
                                            {masters?.Destinos?.find(
                                                (d) => d.id === dg.destino
                                            )?.nombre.replaceAll('_', ' ')}
                                        </td>
                                        <td>{dg.comprador}</td>
                                        <td>{dg.nro_Inscripcion}</td>
                                        <td>{dg.guiaNum}</td>
                                        <td>{dg.variedad}</td>
                                        <td>{dg.kilos} kg</td>
                                        <td>{dg.grado_Gluc}</td>
                                        <td>{dg.precio_Kg}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <section className="DJCEPrint-production-section">
                    <h4>PRODUCCIÓN DE UVA</h4>
                    <table>
                        <thead>
                            <tr>
                                <th>Variedad</th>
                                <th>Superficie</th>
                                <th>Kilos Ingresados</th>
                            </tr>
                        </thead>
                        <tbody>
                            {DJCEData?.djceUvas?.map((it, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{it.variedad}</td>
                                        <td>{it.superficie} m²</td>
                                        <td>{it.kilos} kg</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
                <footer className="DJCEPrint-footer">
                    <label className="DJCEPrint-label">
                        <span>TOTAL KILOS DE PRODUCCIÓN: </span>
                        <p>{DJCEData?.declaracion?.total_Kilos} kg</p>
                    </label>
                </footer>
            </div>
        </div>
    );
}

export default DJCEPrint;
